<template>
  <div class="content_all2" id="old_pass">
    <div class="content_box">

        <div class="list_box w700">
        <div class="y_ititle2">國立臺灣大學校總區戶外球場網路抽籤申請書</div>

        <div class="jubox">
        <table>
          <tr>
            <td colspan="2" class="tx16 txb"><input name="" type="checkbox" value=""> 申請展延</td>
            <td></td>
          </tr>
          <tr>
            <th>申請年度</th>
            <td>106</td>
          </tr>
          <tr>
            <th>申請系所</th>
            <td>資訊工程學系 大學部</td>
          </tr>
          <tr>
            <th>申請類別</th>
            <td>男子籃球隊</td>
          </tr>
          <tr>
            <td colspan="2"><div class="y_ititle2">負責人 / 聯絡人</div></td>
            </tr>
          <tr>
            <td colspan="2" class="tx16 txb"><input name="" type="checkbox" value=""> 更新負責人/聯絡人</td>
          </tr>
          <tr>
            <th>姓名</th>
            <td><input name="" type="text" class="input_style"></td>
          </tr>
          <tr>
            <th>學號</th>
            <td><input name="" type="text" class="input_style"></td>
          </tr>
          <tr>
            <th>電話</th>
            <td><input name="" type="text" class="input_style"></td>
          </tr>
          <tr>
            <th>Email</th>
            <td><input name="" type="text" class="input_style"></td>
          </tr>
          <tr>
            <td colspan="2" class="pt15 pb15"><div class="psbox">注意事項</div></td>
            </tr>
          <tr>
            <td colspan="2" class="text-center tx14"><input name="" type="checkbox" value=""> 我已閱讀相關注意事項</td>
            </tr>    
        </table>
        </div>

        <div class="tomi mt15">
            <button type="submit" class="btn_m">送出申請</button>
            <button type="submit" class="btn_n" @click="goBack">回上一頁</button>
            </div>
        </div>

      </div>
  </div>
</template>


<script>
export default {
  name: 'old_pass',
  data() {
    return {};
  },
  methods: {
    goBack() {
      // window.window.history.go(-1)
      window.history.go(-1)
      
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// OldPass.vue?81d97fc0